module.exports = __webpack_public_path__ + "static/media/arrow-right.bf5b6136.svg";